import { useId } from 'react';

// iQ mark — two-tone: cyan bracket + dark-blue L, transparent background.
export default function BrandLogo({ size = 40, className = '', style = {} }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="5 2 96 96"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      className={className}
      style={{ display: 'block', flexShrink: 0, ...style }}
    >
      {/* Dot — cyan */}
      <circle cx="14" cy="10" r="6" fill="#22D3EE" />

      {/* Top-right bracket — cyan */}
      <path
        fill="#22D3EE"
        d="M 28 7 L 78 7 Q 90 7 90 19 L 90 68 L 77 68 L 77 22 Q 77 20 75 20 L 28 20 Z"
      />

      {/* Bottom-left L — dark blue */}
      <path
        fill="#1B3D7A"
        d="M 8 28 L 8 82 Q 8 92 18 92 L 70 92 L 70 79 L 28 79 Q 21 79 21 72 L 21 28 Z"
      />

      {/* Diagonal Q-tail — dark blue, floating below bracket */}
      <line
        x1="81" y1="76" x2="93" y2="91"
        stroke="#1B3D7A" strokeWidth="11" strokeLinecap="round"
      />
    </svg>
  );
}
